// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1AppUserSchema = z.object({
  id: z.number().int().describe("Unique identifier for the app user connection"),
  name: z.coerce.string().describe("Name of the connected user"),
  email: z.optional(z.coerce.string().describe("Email of the connected user")),
  active: z.boolean().describe("Whether the connection is active"),
  created_at: z.string().datetime().describe("When the connection was created"),
  updated_at: z.string().datetime().describe("When the connection was last updated"),
  first_imported_at: z.string().datetime().describe("When data was first imported").nullish(),
  last_imported_at: z.string().datetime().describe("When data was last imported").nullish(),
  last_exported_at: z.string().datetime().describe("When data was last exported").nullish(),
  disconnected: z.boolean().describe("Whether the connection is disconnected"),
  disconnected_reason: z.coerce.string().describe("Reason for disconnection if applicable").nullish(),
  version: z.coerce.string().describe("Version of the integration").nullish(),
  objects: z.boolean().describe("Whether this integration has objects"),
  manage: z.boolean().describe("Whether the current user can manage this connection"),
  options: z.object({}).describe("Integration configuration options"),
  active_job_ids: z.array(z.number().int()).describe("IDs of currently running import jobs"),
  state: z.coerce.string().describe("Current state of the integration").nullish(),
  resource_id: z.coerce.string().describe("External resource identifier for the integration").nullish(),
  parent: z.object({}).describe("Parent app user if this is a child connection").nullish(),
  objects_type: z.optional(z.coerce.string().describe("Type of objects this integration provides")),
  objects_url: z.optional(z.coerce.string().describe("URL to fetch objects for this integration")),
});
